import { defineComponent as _defineComponent } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from 'pinia'
import { onBeforeMount } from 'vue'
import InputText from '@/components/input/InputText.vue'
import { getMeta } from '@/helpers/general'


export default /*#__PURE__*/_defineComponent({
  __name: 'TwoFactorSetupForm',
  setup(__props) {

const authStore = useAuthStore()

const {
  qrCode,
  userCompletedTwoFactorAuth,
  authCode,
  authCodeInvalid
} = storeToRefs(authStore)

onBeforeMount(async () => {
  await authStore.enableTwoFactorAuth()

  await authStore.fetchQrCode()
})

const submit = async () => {
  if (!authCode.value) return

  authCodeInvalid.value = false

  await authStore.confirmTwoFactorChallenge()
    .then(() => {
      userCompletedTwoFactorAuth.value = true
    })
    .catch((e) => {
      console.error(e)

      if (e?.response?.status === 422) {
        authCodeInvalid.value = true
      }
    })

  if (userCompletedTwoFactorAuth.value) {
    // redirects to the desired page when user is authenticated
    return window.location.href = '/'
  }
}

return { __sfc: true,authStore, qrCode, userCompletedTwoFactorAuth, authCode, authCodeInvalid, submit, InputText, getMeta }
}

})